import DraggableList from "../Lists/DraggableList";
import { IItemListProps, IListItemProps } from "../interfaces";
import { mergeClass } from "../../utils";
import { ItemWithPublish } from "./SlideItem";

const slideListItem = (props: IListItemProps) => <ItemWithPublish {...props} />;

export const ListWithPublish = ({
  sortable,
  ...restProps
}: IItemListProps): JSX.Element => {
  const { data, modelName } = restProps;

  if (data.length < 1) return <div className="opacity-50">None</div>;

  return (
    <div
      className={mergeClass({
        "flex flex-wrap gap-5": modelName,
        "space-y-2": modelName === "users",
      })}
    >
      <DraggableList
        {...restProps}
        modelName={modelName}
        isCard={modelName !== "users"}
        customListItem={slideListItem}
      />
    </div>
  );
};
